// src/components/Contact.js
import React, { useState } from 'react';
import "bootstrap/dist/css/bootstrap.min.css"; 
import '../styles/contact.scss';
import { ToastContainer, toast } from 'react-toastify';
import { Container, Row, Col } from "react-bootstrap";
import emailjs from 'emailjs-com';
import "react-toastify/dist/ReactToastify.css";


// Assicurati di configurare il tuo Public Key nel tuo codice
const contactConfig = {
  YOUR_EMAIL: 'corinnezoccali1999@gmail.com',
  YOUR_FONE: '(+39) XYZ-XYZ-WXYZ',
  description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vehicula eu nunc et sollicitudin. Cras pulvinar, nisi at imperdiet pharetra. ',
    YOUR_SERVICE_ID: 'service_gmihwnb', // Sostituisci con il tuo Service ID
    YOUR_TEMPLATE_ID: 'template_nx67lpl', // Sostituisci con il tuo Template ID
    YOUR_USER_ID: 'dRxv2kYKWp53tCr8S', // Sostituisci con il tuo User ID
};

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      contactConfig.YOUR_SERVICE_ID,
      contactConfig.YOUR_TEMPLATE_ID,
      e.target,
      contactConfig.YOUR_USER_ID // Usa il tuo User ID
    ).then(
      (result) => {
        toast.success('Message sent successfully!'); // Mostra il popup di successo
        setFormData({ name: '', email: '', message: '' }); // Reset form
      },
      (error) => {
        toast.error('Message failed to send. Please try again.'); // Mostra il popup di errore
        console.error('Send email error:', error.text); // Aggiungi per il debug
      }
    );
  };



  return (
    <Container className="Container">
      <ToastContainer
        position="top-right"
        autoClose={5000} // Durata della notifica in millisecondi
        hideProgressBar={true} // Nasconde la barra di progresso
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Row className="mb-5 mt-3">
        <Col lg="8">
          <h1 className="display-4 mb-4">Contact </h1>
          <hr className="t_border my-4 ml-0 text-left" />
        </Col>
      </Row>
      <Row className="sec_sp">
        <Col lg="7" className="d-flex align-items-center">
          <form onSubmit={handleSubmit} className="contact__form w-100">
            <Row>
              <Col lg="6" className="form-group">
                <input
                  className="form-control"
                  id="name"
                  name="name"
                  placeholder="Name"
                  type="text"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Col>
              <Col lg="6" className="form-group">
                <input
                  className="form-control rounded-0"
                  id="email"
                  name="email"
                  placeholder="Email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Col>
            </Row>
            <textarea
              className="form-control rounded-0"
              id="message"
              name="message"
              placeholder="Message"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            <br />
            <Row>
              <Col lg="12" className="form-group">
                <button className="btn ac_btn" type="submit">
                  Send
                </button>
              </Col>
            </Row>
          </form>
        </Col> <Col lg="5" className="d-flex align-items-start">
          <div className="contact-info">
            <h4>Contact Info</h4>
            <p>Email: <a href={`mailto:${contactConfig.YOUR_EMAIL}`}>{contactConfig.YOUR_EMAIL}</a></p>
            <div className="social-links">
              <h5>Follow us</h5>
              <a href="https://instagram.com/corinnezoccali" target="_blank" rel="noopener noreferrer">
                <img src="./instagram.png" alt="Corinne Zoccali" />
              </a>
              <a href="https://www.linkedin.com/in/corinnezoccali/" target="_blank" rel="noopener noreferrer" className="social-link small-icon">
                <img src="./linkedin.png" alt="Corinne Zoccali" />
              </a>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Contact;